var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details-card-wrapper"},[(!_vm.ancillary)?_c('div',[_vm._v("Nessun dato disponibile per questo titolo.")]):_c('info-card',{attrs:{"title":"Dati del titolo","rows":_vm.rows}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }